import {useQuery} from '@tanstack/react-query'

import {getMenuItemCategoryList} from '@/lib/food-grubhub/foodGrubhubService'
import type {CategoryListQuery} from '@/lib/food-grubhub/foodRestaurantDetailModel'

const useMenuItemCategoryListing = (params: CategoryListQuery, token: string) => {
  return useQuery({
    queryKey: ['menu_item_category_listing', params, token],
    queryFn: async () =>
      getMenuItemCategoryList({
        orderType: params.orderType,
        platform: params.platform,
        enhancedFeed: params.enhancedFeed,
        weightedItemDataIncluded: params.weightedItemDataIncluded,
        location: params.location,
        viewport: params.viewport,
        restaurantId: params.restaurantId,
        token,
        signal: undefined,
      }),
    enabled: !!token,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 5,
  })
}

export default useMenuItemCategoryListing
